export namespace TemplatesActions{
    export class SetTATemplate {
        static readonly type = '[Templates] SetTATemplate';
        constructor() {}
    }
    export class SetTASearchTemplate {
        static readonly type = '[Templates] SetTASearchTemplate';
        constructor() {}
    }
    export class SetTCTemplate {
        static readonly type = '[Templates] SetTCTemplate';
        constructor() {}
    }
    export class SetTCSearchTemplate {
        static readonly type = '[Templates] SetTCSearchTemplate';
        constructor() {}
    }
    export class SetTSTemplate {
        static readonly type = '[Templates] SetTSTemplate';
        constructor() {}
    }
    export class SetTSSearchTemplate {
        static readonly type = '[Templates] SetTSSearchTemplate';
        constructor() {}
    }
    export class SetTSpecTemplate {
        static readonly type = '[Templates] SetTSpecTemplate';
        constructor() {}
    }
    export class SetTSpecSearchTemplate {
        static readonly type = '[Templates] SetTSpecSearchTemplate';
        constructor() {}
    }
    export class SetTCoverageTemplate {
        static readonly type = '[Templates] SetTCoverageTemplate';
        constructor() {}
    }
    export class SetTCoverageSearchTemplate {
        static readonly type = '[Templates] SetTCoverageSearchTemplate';
        constructor() {}
    }
    export class SetSwVersionCoverageTemplate {
        static readonly type = '[Templates] SetSwVersionCoverageTemplate';
        constructor() {}
    }
    export class SetSwVersionCoverageSearchTemplate {
        static readonly type = '[Templates] SetSwVersionCoverageSearchTemplate';
        constructor() {}
    }
    export class SetEeseCoverageTemplate {
        static readonly type = '[Templates] SetEeseCoverageTemplate';
        constructor() {}
    }
    export class SetEeseCoverageSearchTemplate {
        static readonly type = '[Templates] SetEeseCoverageSearchTemplate';
        constructor() {}
    }
}